/* eslint-disable @typescript-eslint/no-explicit-any */
import { getActiveAuthSelector } from 'selectors/appSelectors';
import { googleAnalyticsScriptsLoadedSelector } from 'selectors/cookieConsentSelectors';
import { uaAddScript, uaSetupTracking } from 'utils/analytics/ua';
import { useActions } from '@tock/shared/utils/connect';
import { useConsentRestrictedScripts } from 'hooks/useConsentRestrictedScripts';
import { useSelector } from 'react-redux';
import AppSettings from 'settings/AppSettings';
import React from 'react';
import analytics from 'utils/Analytics';

const windowObj = window as any;

export const GoogleAnalytics: React.FC<React.PropsWithChildren<unknown>> = () => {
  const activeAuth = useSelector(getActiveAuthSelector);
  const scriptAdded = useSelector(googleAnalyticsScriptsLoadedSelector);
  const { actions } = useActions();
  const { consentLevelFunctional, consentLevelAdvertising } = useConsentRestrictedScripts();

  // Load script
  React.useEffect(() => {
    if (consentLevelFunctional) {
      if (!scriptAdded) {
        uaAddScript({ advertisingEnabled: consentLevelAdvertising });
        uaSetupTracking(AppSettings.GA_PROPERTY_ID, AppSettings.TOCK2US_GA_PROPERTY_ID);

        actions.cookieConsent.updateScriptLoad(true);
      }

      windowObj[`ga-disable-${AppSettings.GA_PROPERTY_ID}`] = false;
    } else {
      windowObj[`ga-disable-${AppSettings.GA_PROPERTY_ID}`] = true;
    }
  }, [consentLevelFunctional, consentLevelAdvertising, scriptAdded, actions.cookieConsent]);

  // Set custom dimensions
  // This includes business and user details with all events
  React.useEffect(() => {
    if (scriptAdded && activeAuth) {
      analytics.setActiveAuthCustomDimensions(activeAuth);
    }
  }, [scriptAdded, activeAuth]);

  return null;
};
